import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Section from '../components/common/Section';
import AuthRoutes from '../routes/AuthRoutes';
import bg1 from '../assets/img/generic/condominium.jpg';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import logo from '../assets/img/illustrations/logo.png';

const AuthBasicLayout = () =>
<Section className="py-0" image={bg1} style={{ backgroundSize: 'cover' }}  position="center bottom" overlay>
  <Row className="flex-center min-vh-100 py-6">
    <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
      <Card>
        <Link to='/' className='d-flex align-items-center justify-content-center pt-5 pb-2'>
          <img src={logo} alt='Logo de Homelan' width={'50%'}/>
        </Link>
        <CardBody className="fs--1 font-weight-normal p-5">
          <AuthRoutes />
        </CardBody>
      </Card>
    </Col>
  </Row>
</Section>

export default AuthBasicLayout;